import cloneDeep from 'lodash.clonedeep';

export default function storeReset(plugin: any) {
  const initialState = cloneDeep(plugin.store.$state);
  plugin.store.$reset = () => plugin.store.$patch(cloneDeep(initialState));
}
